import { render, staticRenderFns } from "./CustomFeeItem.vue?vue&type=template&id=1340fb7c&scoped=true"
import script from "./CustomFeeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFeeItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomFeeItem.vue?vue&type=style&index=0&id=1340fb7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1340fb7c",
  null
  
)

export default component.exports